import React from 'react';

interface PaginationProps {
  isDisabled: boolean;
  clickHandler: () => void;
  children: React.ReactNode;
}

function PaginationCTA({ isDisabled, clickHandler, children }: PaginationProps): React.ReactElement {
  return (
    <button type="button" className="rolex-button" disabled={isDisabled} onClick={clickHandler}>
      {children}
    </button>
  );
}

export default PaginationCTA;
